module.exports = __webpack_public_path__ + "img/custom_media_activity_zs.008e2e80.png";